export default __webpack_public_path__ + "static/media/rotax_logo_white.6c9f67d1.svg";